import React from 'react'
import { Container,Row,Col, Button } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import './RightSidebar.css';

const styles = createUseStyles( theme => ({
    ButtonPrimary: {
        backgroundColor: theme.colorPrimary,
        borderColor: theme.colorPrimary,
    }
}) )

const RightSidebar = ({status,setStatus,children,title,props,onClose}) => {
    
    const classes = styles();

  return (
    <div className={`ws-right-siderbar ${ (status) && 'active' }`} {...props}>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3 ws-sidebar-right-header d-flex justify-content-between align-items-center">
                        <p className='mb-0 ws-sidebar-right-header-title'>{title}</p>
                        <i className="material-icons ws-sidebar-right-close" 
                        onClick={
                            () => {
                                setStatus(!status)
                                onClose();
                            }
                        }>clear</i>
                    </div>
                </Col>
            </Row>
        </Container>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

const RightSidebarInter = ({status,setStatus,children,title,props,onClose}) => {
    
    const classes = styles();

  return (
    <div className={`ws-right-siderbar ${ (status) && 'active' }`} {...props}>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="pt-2 pb-2 ps-1 pe-1 ws-sidebar-inter-right-header d-flex justify-content-between align-items-center">
                        <p className='mb-0 ws-sidebar-inter-right-header-title'>{title}</p>
                        <Button className="ws-sidebar-inter-right-header-button"><i class="bi bi-plus"></i>&nbsp;Agregar</Button>
                        <i className="material-icons ws-sidebar-right-close" 
                        onClick={
                            () => {
                                setStatus(!status)
                                onClose();
                            }
                        }>clear</i>
                    </div>
                </Col>
            </Row>
        </Container>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export{
    RightSidebar,
    RightSidebarInter,
}
